import type { DrawerState } from '../index';

export const setFilters = (state: DrawerState, { payload }: { payload: DrawerState['appliedFilters'] }) => {
  state.appliedFilters = {
    ...state.appliedFilters,
    ...payload,
  };
};

export const setDefaultFiltersOnlyIfNoFilterApplied = (state: DrawerState, { payload }: { payload: DrawerState['appliedFilters'] }) => {
  payload &&
    Object.keys(payload).forEach((key) => {
      if (!state.appliedFilters || !state.appliedFilters[key]) {
        if (!state.appliedFilters) {
          state.appliedFilters = {};
        }
        state.appliedFilters[key] = payload[key];
      }
    });
};

/** @deprecated DO NOT USE. Used only in Jest tests.
 * Should be removed when Jest tests are fixed. */
export const setFiltersToApply = (state: DrawerState, { payload }: { payload: DrawerState['appliedFilters'] }) => {
  console.log('setFiltersToApply() USED JUST IN TESTS:', state, payload);
};

export const setSavedFilters = (state: DrawerState, { payload }: { payload: DrawerState['savedFilters'] }) => {
  state.savedFilters = payload;
};

export const resetFilters = (state: DrawerState) => {
  state.appliedFilters = {};
  state.savedFilters = {};
};
